import React, {Component} from 'react'
import PropTypes from 'prop-types'
import LazyLoad from 'react-lazyload'

class OrderSelection extends Component {
    _detectChecked = () => {
        const {orderId, selectedOrders} = this.props

        return selectedOrders.includes(orderId)
    }

    _handleChange = () => {
        const {orderId, onUpdateOrdersSelected} = this.props

        const isChecked = this._detectChecked()

        onUpdateOrdersSelected(orderId, !isChecked)
    }

    render() {
        const {haveStatus, cancelStatus} = this.props
        const isChecked = this._detectChecked()

        return (
            <td className='OrderSelection'>
                <LazyLoad>
                    <div className='custom-control custom-checkbox'>
                        <input type='checkbox' disabled={haveStatus || cancelStatus} checked={isChecked}
                            id={`checkbox_${this.props.orderId}`}
                            className='custom-control-input' onChange={this._handleChange}/>
                        <label htmlFor={`checkbox_${this.props.orderId}`} className='custom-control-label'/>
                    </div>
                </LazyLoad>
            </td>
        )
    }
}

OrderSelection.propTypes = {
    orderId: PropTypes.string.isRequired,
    selectedOrders: PropTypes.array.isRequired,
    onUpdateOrdersSelected: PropTypes.func.isRequired,
}

export default OrderSelection
